import Collection from '../core/Collection';

export default (object: object): Collection => new Collection(object);
